import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../src/core/api/axiosClient';


const initialState: any = {
    schedules: [],
    isLoading: false,
    error: null,
}

export const getSchedules: any = createAsyncThunk('content/getSchedules',
    async ({ PageNumber, pageSize }: any) => {
        const res = await axios('http://localhost:3000/schedules', {
            params: { PageNumber, pageSize }
        });
        const data = await res.data
        return data
    }
)

export const scheduleSlice = createSlice({
    name: 'schedule',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getSchedules.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(getSchedules.fulfilled, (state, action) => {
            state.isLoading = false
            state.schedules = action.payload
        })
        builder.addCase(getSchedules.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
    },
})

export default scheduleSlice.reducer
